module.exports = __webpack_public_path__ + "img/slogan.8d313815.png";